import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import {
  FLAG_GETTING_MAINTENANCE_BUS_FLEETS,
  GET_MAINTENANCE_BUS_FLEETS,
  CLEAR_MAINTENANCE_BUS_FLEETS,
  GET_HISTORY_OF_BUS_MAINTENANCE_STAY,
  CLEAR_HISTORY_OF_BUS_MAINTENANCE_STAY,
  FLAG_GETTING_HISTORY_OF_BUS_MAINTENANCE_STAY
} from '../types'

import { MAINTENANCE_BUS_FLEET_ENDPOINT, REGISTERED_BUS_FLEET_ENDPOINT } from '../../config/endpoints';

import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';


import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingMaintenancedBusFleets = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_MAINTENANCE_BUS_FLEETS,
  });

const getMaintenancedBusFleets = async (
  parameters = {}
) => async (dispatch) => {
  try {

    dispatch(flagGettingMaintenancedBusFleets(true));
    const url = `${MAINTENANCE_BUS_FLEET_ENDPOINT}?${QueryString.stringify(parameters)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_MAINTENANCE_BUS_FLEETS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingMaintenancedBusFleets(false));
  }
}

const clearMaintenancedBusFleets = () => (dispatch) =>
  dispatch({
    type: CLEAR_MAINTENANCE_BUS_FLEETS,
  });

const flagGettingHistoryOfBusMaintenanceStay = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_HISTORY_OF_BUS_MAINTENANCE_STAY,
  });

const clearHistoryOfBusMaintenanceStay = () => (dispatch) =>
  dispatch({
    type: CLEAR_HISTORY_OF_BUS_MAINTENANCE_STAY,
  });


const getHistoryOfBusMaintenanceStay = async (busMaintenanceStayId) => async (dispatch) => {
  try {
    dispatch(flagGettingHistoryOfBusMaintenanceStay(true));
    const url = `${MAINTENANCE_BUS_FLEET_ENDPOINT}/bus-maintenance-stay/${busMaintenanceStayId}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_HISTORY_OF_BUS_MAINTENANCE_STAY,
      payload: response,
    });
  }
  catch ({ message }) {
    toastr.error('Error', message);
  }
  finally {
    dispatch(flagGettingHistoryOfBusMaintenanceStay(false));
  }
}

const getExportRegisteredBusFleet = async ({
  fromDateString,
  toDateString,
}) => async (dispatch) => {
  try {
    dispatch(flagGettingMaintenancedBusFleets(true));
    const url = `${REGISTERED_BUS_FLEET_ENDPOINT}/export-history?${QueryString.stringify({ fromDateString, toDateString })}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const blob = await promise.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `flota_registrada_${Date.now()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingMaintenancedBusFleets(false));
  }
}


export {
  getMaintenancedBusFleets,
  clearMaintenancedBusFleets,
  getHistoryOfBusMaintenanceStay,
  clearHistoryOfBusMaintenanceStay,
  flagGettingMaintenancedBusFleets,
  getExportRegisteredBusFleet
}